import FetchCall from '../../../shared/local_fetch_call'
const namespaced = true

const state = {
  section: 'none',
  number: 1,
  paymentFields: {},
  hotelInCart: true,
  topDiv: null,
  applyCredit: true,
  creditAmount:0,
  potentialCredit: 0,
  orderTotal:0,
  billing: {
    address1: '',
    address2: '',
    city: '',
    companyName: '',
    corporate: false,
    country: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    purchaseOrderNumber: '',
    state: '',
    zipCode: ''
  },
  docusignUrl: '',
  docusignLoader: false,
  docusignStatus: '',
  loadingDocusignStatus: false
}

const mutations = {
  updatePaymentFields(state, newFields) {
    const pf = state.paymentFields
    state.paymentFields = Object.assign({}, pf, newFields)
  },
  updateHotelInCart(state, hotelInCart) {
    state.hotelInCart = hotelInCart
  },
  updateCreditAmount(state, amount) {
    state.creditAmount = amount
  },
  toggleCreditApplication(state){
    state.applyCredit = !state.applyCredit
  },
  setOriginalCredit(state, amount){
    state.potentialCredit=amount
  },
  updateOrderTotal(state, amount) {
    state.orderTotal = amount
  },
  updateSection(state, section) {
    if (state.section == section) {
      state.section = 'none'
    } else {
      if (state.topDiv) {
        state.topDiv.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
      state.section = section
    }
  },
  updateSectionNumber(state, numberOfAddOns) {
    if (numberOfAddOns > 0) {
      state.number = 0
    } else {
      state.number = 1
    }
  },

  setTopDiv(state, div) {
    state.topDiv = div
  },
  updateFirstName(state, firstName) {
    state.billing.firstName = firstName
  },
  updateAddress1(state, address1) {
    state.billing.address1 = address1
  },
  updateAddress2(state, address2) {
    state.billing.address2 = address2
  },
  updateCity(state, city) {
    state.billing.city = city
  },
  updateCompanyName(state, name) {
    state.billing.companyName = name
  },
  updateCorporate(state, value) {
    state.billing.corporate = value
  },
  updateCountry(state, country) {
    state.billing.country = country
  },
  updateLastName(state, lastName) {
    state.billing.lastName = lastName
  },
  updatePhoneNumber(state, phoneNumber) {
    state.billing.phoneNumber = phoneNumber
  },
  updatePurchaseOrderNumber(state, pon) {
    state.billing.purchaseOrderNumber = pon
  },
  updateState(state, stateName) {
    state.billing.state = stateName
  },
  updateZipCode(state, zipCode) {
    state.billing.zipCode = zipCode
  },
  updateDocusignUrl(state, url) {
    state.docusignUrl = url
  },
  updateDocusignLoader(state, loader) {
    state.docusignLoader = loader
  },
  updateDocusignStatus(state, status) {
    state.docusignStatus = status
  },
  updateLoadingDocusignStatus(state, loading) {
    state.loadingDocusignStatus = loading
  }
}

const actions = {
  async updateSection({ commit, state }, section) {
    let replacedSection = state.section
    commit('updateSection', section)

    if (replacedSection == 'address') {
      commit('updateDocusignLoader', true)
      let body = JSON.stringify({
        order: {
          first_name: state.billing.firstName,
          last_name: state.billing.lastName,
          corporate_group: state.billing.corporate,
          phone: state.billing.phoneNumber,
          street_1: state.billing.address1,
          street_2: state.billing.address2,
          state: state.billing.state,
          country: state.billing.country,
          zip_code: state.billing.zipCode,
          company_name: state.billing.companyName,
          purchase_order_number: state.billing.purchaseOrderNumber
        }
      })

      await FetchCall.fetchWithoutLocale(
        '/cart',
        'PUT',
        body
      )
      commit('updateDocusignLoader', false)
    } else if (replacedSection == 'hotel' && state.paymentFields.roomInformation.length > 0) {
      updateHotelReservationInfo(state.paymentFields.roomInformation)
    }
  },
  async generateDocusign({commit}) {
    commit('updateDocusignLoader', true)

    let docusignResponse = await FetchCall.fetchWithoutLocale(
      '/api/checkout_signatures',
      'POST',
      null
    )

    if (!docusignResponse.docusign_url) {
      console.log('Doc:', docusignResponse)
      commit('updateDocusignLoader', false)
      return
    }

    window.location.href = docusignResponse.docusign_url
    commit('updateDocusignLoader', false)
  }
}

const getters = {

}

const updateHotelReservationInfo = async (roomInformation) => {
  roomInformation.forEach(async info => {
    let body = JSON.stringify({
      hotel_reservations: {
        name: info.name,
        number_of_adults: info.numberOfAdults
      }
    })
    await FetchCall.fetchWithoutLocale(
      `/api/checkout_hotel_reservations/${info.id}`,
      'PUT',
      body
    )
  })
}

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
